import {
  INITIATE_GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_FAIL,
  SET_PENDING_TRANSFER_TYPE,
} from "../../actionTypes/dashboard";

export const DEFAULT_TRANFER_TYPE = "assignedToMe";

const INITIAL_STATE = {
  user: {},
  transferPendingType: DEFAULT_TRANFER_TYPE,
  isLoading: false,
  error: "",
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INITIATE_GET_DASHBOARD_DATA:
      return { ...state, isLoading: true };
    case GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: { ...state.user, ...action.payload },
      };
    case SET_PENDING_TRANSFER_TYPE:
      return { ...state, transferPendingType: action.payload };
    case GET_DASHBOARD_DATA_FAIL:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return { ...state };
  }
};

export default reducer;
